module.exports = function getResource(label, vars = []) {
    let resources = {
        placeOrder: 'Place Order',
        placeKlarnaOrder: 'Continue to Klarna',
        placePayBrightOrder: 'Continue to PayBright',
        orderTotal: 'Order total',
        item: 'item',
        items: 'items',
        authorizeErrorMessage: 'Trouble connecting to Klarna. Please use a different payment method or try again later.',
        denialMessage: `We’re sorry! ${vars[0]} payment could not be authorized. Please select a different payment method.`
    };

    return resources[label];
};
